<template>
  <inventoryProductsSubCategoriesForm :typeEndPoint="'restaurantProductsSubCategoriesForm'" :dataParams="{}" />
</template>
<script>
import inventoryProductsSubCategoriesForm from '@/components/modules/restaurant/products/subcategories/form'
export default {
  name: 'inventoryProductsSubCategories',
  components: {
    inventoryProductsSubCategoriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}

</script>



// WEBPACK FOOTER //
// src/views/restaurant/products/subcategories/create.vue